import * as React from "react";
import { useEffect } from "react";
import { FeatureProveSrc } from "../app/consts";
import { useConfig } from "./config/ConfigContext";
import { getConsentForCategory } from "./Termly";

declare global {
  interface Window {
    o: {
      _provesrcAsyncInit: Function;
    };
    provesrc: {
      init: Function | null;
      dq: any[];
      display: Function;
    };
  }
}

const proveSrcInit = function () {
  // console.log("Prove Source Init");
  (function (win, doc, url) {
    if (!doc.querySelector('script[src*="' + url + '"]')) {
      win.provesrc && win.console && console.error && console.error("ProveSource is included twice in this page.");
      win.provesrc = {
        init: null,
        dq: [],
        display: function () {
          this.dq.push(arguments);
        }
      };
      var run = false;
      win.o = {
        _provesrcAsyncInit: function () {
          if (!run) {
            run = true;
            if (win.provesrc.init) {
              win.provesrc.init({
                apiKey:
                  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY2NvdW50SWQiOiI2MDlkODBmODgyNzJlNDYyZTFmOTc2NGEiLCJpYXQiOjE2MjA5MzQ5MDR9.k8_M97HfFO80WlFoTjU2hrJsALHTmCLYtqIuutTkuUg",
                v: "0.0.4"
              });
            }
          }
        }
      };

      var head = doc.getElementsByTagName("head")[0];
      var script = doc.createElement("script");
      script.async = true;
      script.src = url;
      head.appendChild(script);

      setTimeout(() => {
        win.o._provesrcAsyncInit();
      }, 2000);
    }
  })(window, document, "https://cdn.provesrc.com/provesrc.js");
};

export const Provesrc = () => {
  const { isFeatureEnabled } = useConfig();
  const [hasConsent, setHasConsent] = React.useState(getConsentForCategory("advertising"));

  useEffect(() => {
    const handleConsentChange = () => {
      setHasConsent(getConsentForCategory("advertising"));
    };

    window.addEventListener("consentStatusUpdated", handleConsentChange);

    return () => {
      window.removeEventListener("consentStatusUpdated", handleConsentChange);
    };
  }, []);

  useEffect(() => {
    if (isFeatureEnabled(FeatureProveSrc) && hasConsent) {
      proveSrcInit();
    }
  }, [isFeatureEnabled, hasConsent]);
  return <React.Fragment />;
};
